exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.BeMS3c9c1TmnppGlEFGVb{font-size:0.7em}._2lya3ViSlcIs_xSju8ZIwl{border-radius:.28571rem}._1V4LxBcNZ1ZIunz8X1a2e_{border-radius:50%}._1VXABeUBawuAV06YRvO2x9{font-weight:bolder}._2Rh_reQ-5Nc3ChoN4Sk7su{word-break:break-all;color:black}._2PJ-1r-4cjuz7WNgjmMF5C{font-size:1rem;font-weight:600;color:#757d8c}\n", ""]);

// exports
exports.locals = {
	"labelSizeXS": "BeMS3c9c1TmnppGlEFGVb",
	"statusBorderRadius": "_2lya3ViSlcIs_xSju8ZIwl",
	"borderRadiusCircle": "_1V4LxBcNZ1ZIunz8X1a2e_",
	"textBolder": "_1VXABeUBawuAV06YRvO2x9",
	"wordBreakAll": "_2Rh_reQ-5Nc3ChoN4Sk7su",
	"packageStatus": "_2PJ-1r-4cjuz7WNgjmMF5C"
};